import { useTranslation } from "react-i18next";

const TaskInfo = ({ type, onClick }) => {
  const { t } = useTranslation();

  if (type === "priority") {
    return (
      <>
        <button type="button" onClick={onClick}>
          {t("Click")}
        </button>{" "}
        {t("and find out more about the priorities.")}
      </>
    );
  }

  return (
    <>
      <button type="button" onClick={onClick}>
        {t("Click")}
      </button>{" "}
      {t("and find more about statuses.")}
    </>
  );
};

export default TaskInfo;
